import { useAppSelector } from '@/app/hooks';
import { useCheckoutQueue } from '@/features/checkout/checkoutQueue';
import { useOnlineOrderSummary } from '@/features/onlineorders/useOnlineOrderSummary';
import type { NavBadge } from './navItems';

export function useNavBadges(): Record<NonNullable<NavBadge>, number> {
    const cart = useAppSelector((s) => s.cart.items.reduce((sum, i) => sum + i.quantity, 0));
    const held = useAppSelector((s) => s.cart.heldCartCount ?? 0);
    const queued = useCheckoutQueue().length;
    const orders = useOnlineOrderSummary()?.newPaidCount ?? 0;
    return { cart, queued, orders, held };
}
